//Returns date string in format yyyy-mm-dd
function getDateString(dt) {
  let dd = dt.getDate();
  let mm = dt.getMonth() + 1;
  let yyyy = dt.getFullYear();

  let dd_str = (dd < 10) ? ("0" + dd) : dd;
  let mm_str = (mm < 10) ? ("0" + mm) : mm;

  let dt_str = yyyy + "-" + mm_str + "-" + dd_str;
  //console.log("getDateString dt = " + dt_str);

  return dt_str;
};

//Returns month fully spelled out
function getFullMonth(index) {
  var month = [];
  month[0] = "January";
  month[1] = "February";
  month[2] = "March";
  month[3] = "April";
  month[4] = "May";
  month[5] = "June";
  month[6] = "July";
  month[7] = "August";
  month[8] = "September";
  month[9] = "October";
  month[10] = "November";
  month[11] = "December";

  return month[index];
}

//Returns Day of Week spelled out
function getDayOfWeek(index) {
	var day_of_week = [];
  day_of_week[0] = "Sunday";
  day_of_week[1] = "Monday";
  day_of_week[2] = "Tuesday";
  day_of_week[3] = "Wednesday";
  day_of_week[4] = "Thursday";
  day_of_week[5] = "Friday";
  day_of_week[6] = "Saturday";

  return day_of_week[index];
}

//Returns date string in format MMddyyyy
function getDateStringMMddyyyy(dt) {
  var month_str = getFullMonth(dt.getMonth());
  var day = dt.getDate();
  var day_str = "" + day;

  if(day == 1 || day == 21 || day == 31) {
    day_str += "st";
  }
  else if (day == 2 || day == 22 ) {
    day_str += "nd";
  }
  else {
    day_str += "th";
  }

  return month_str + " " + day_str + ", " + dt.getFullYear();
}

function getFullDateString(dt_str) {
	var dt = new Date(dt_str);
	var month_str = getFullMonth(dt.getMonth());
	var day_str = dt.getDate();
	var year_str = dt.getFullYear();

	return month_str + " " + day_str + ", " + year_str;

}

//time_str is in HH:mm format and returns time in AM/PM format 
function getAMPMTimeString(time_str) {
	var colon_index = time_str.indexOf(":");
	var hour = parseInt(time_str.substring(0, colon_index));
	var am_pm = "AM";
	if(hour > 11) {
		am_pm = "PM";
	}

	hour = hour % 12;
	var hour_str = "" + hour;
	if(hour == 0) {
		hour_str = "12";
	}

	var min_str = time_str.substring(colon_index + 1, time_str.length);
	
	return hour_str + ":" + min_str + " " + am_pm;
}

/*function getHouseCallTimeFramesJSON() {
	var timeframes = [
		{
			start: '10:00'
			, end: '13:00'
			, army_text: '10:00 - 13:00'
			, friendly_text: '10:00 AM to 1:00 PM'
		},
		{
			start: '14:30'
			, end: '17:30'
			, army_text: '14:30 - 17:30'
			, friendly_text: '2:30 PM to 5:30 PM'
		},
		{
			start: '17:30'
			, end: '20:30'
			, army_text: '17:30 - 20:30'
			, friendly_text: '5:30 PM to 8:30 PM'
		}
	];

	return timeframes;
}
*/


//////////////////////////////Delivery Dates Functions//////////////////////////////


const DELIVERY_DATE_FORMAT = "yyyy-mm-dd";
const ZONE_DELIVERY_SUFFIX = "[DISCOUNT APPLIED]";

//variant is a JSON structure
//This date sets up the start and end date we limit ourselves to from the current date of order.
//Current delivery date range:
//  Start Date is 2 days later
//  End Date is 2 weeks after Start Date (or 16 days from current date)
function filterAvailableDeliveryDates(variant) {
  const DAYS_IN_WEEK = 7;

  var start_date = new Date();
  var days_later_start = 2;

  start_date.setDate(start_date.getDate() + days_later_start);

  var days_later_end = days_later_start + 2 * DAYS_IN_WEEK - 1; // 16 days later
  var end_date = new Date();
  end_date.setDate(end_date.getDate() + days_later_end);

  var title = variant.title;
  if(title.includes(ZONE_DELIVERY_SUFFIX)) {
    return false;
  }
    
  title = title.substring(0, DELIVERY_DATE_FORMAT.length);

  if(variant.available && title >= getDateString(start_date) && title <= getDateString(end_date)) {
    return true;
  }

  return false;
}


/* Get nth instance of a particular weekday in a month
 *
 * @param {number|string} nth - instance of day, 1 to 5
 * @param {number|string} day - day of week, Sun 0, Mon 1, etc.
 * @param {Date} month - any date in month to get day of
 * @returns {Date} that is nth instance of day in month
*/
function getNthDayInMonth(nth, day, month) {
  if(nth > 5) {
    return null;
  }

  // Create new date for 1st of month
  let d = new Date(month.getFullYear(), month.getMonth());
  // Move to first instance of day in month and 
  // add (n - 1) weeks
  d.setDate(1 + (7 - d.getDay() + day)%7 + (nth - 1)*7);
  return d;
}

//This currently sets the span with class free_dev_station_dt to free delivery station date.
//In this case, the 3rd Tuesday of each month is our free delivery date.
function setFreeDeliveryStationDate() {
  var today = new Date();
  today.setHours(0,0,0,0);

  var two_days_later = today;
  two_days_later.setDate(today.getDate() + 2);

  //Get 3rd Tuesday of current month
  var this_months_date = getNthDayInMonth(3, 2, today);

  if(this_months_date >= two_days_later) {
    $(".free_dev_station_dt").html(getFullDateString(this_months_date));

    return;
  }

  var next_month = today;
  next_month.setMonth(today.getMonth() + 1);

  var next_months_date = getNthDayInMonth(3, 2, next_month);

  $(".free_dev_station_dt").html(getFullDateString(next_months_date));
}